import { ArrowLeft } from "@winamp/icons/ArrowLeft.js";
import { Button } from "../Button";

export function DialogBack({
  ...props
}: React.ComponentPropsWithoutRef<typeof Button>) {
  return (
    <Button icon variant="ghost" size="sm" {...props}>
      <ArrowLeft />
    </Button>
  );
}
